import React, { forwardRef, useEffect, useImperativeHandle, useMemo } from "react";
import { createNewGuest } from 'adminApi/CreateBookingCustomer/CreateBookingCustomerApi';
import fields from "./json/CustomerFeilds.json";
import useFormChange from 'Hooks/useFormChange';
import { bookingTimeGuestRules } from 'validation/ValidationRules';
import useFormSubmit from 'Hooks/useFormSubmit';
import { validateForm } from 'utils/validation';
import FormSelect from "Common/Custom/FormSelect";
import FormPhoneInput from "Common/Custom/FormPhoneInput";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import Spinner from "Common/Globle/Spinner";



// -------------------- NEW GUEST FORM --------------------
export const CreateNewGuestForm = forwardRef(({ onGuestCreated }, ref) => {

    const allFields = useMemo(() => [...fields.guest_details, { name: "country_dial_code" }], []);

    const initialValues = useMemo(() => {
        return allFields.reduce((acc, field) => {
            acc[field.name] = field.name === "country_dial_code" ? "+91" : "";
            return acc;
        }, {});
    }, [allFields]);


    const { values, errors, handleChange, handleFileChange, setErrors } =
        useFormChange(initialValues, bookingTimeGuestRules);

    const { loading: loadingSubmit, handleSubmit, response } = useFormSubmit(
        async (formValues) => {
            delete formValues.id_proof_frontPreview;
            delete formValues.id_proof_backPreview;

            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                formData.append(key, val ?? "");
            });
            return await createNewGuest({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, bookingTimeGuestRules);
            console.log("Guest Create Form Validation Errors", err);
            setErrors(err);
            return err;
        },
        () => '',
        "Guest Created successfully!"
    );

    useEffect(() => {
        if (response?.data) {
            const { guest_id, guest_name, guest_phone, country_dial_code } = response.data;
            onGuestCreated({ guest_id, guest_name, guest_phone, country_dial_code });
        }
    }, [response, onGuestCreated]);

    const { guest_details } = fields;

    const renderField = (field) => {
        switch (field.type) {
            case "select":
                return (
                    <FormSelect
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        options={field.options}
                        error={errors[field.name]}
                    />
                );
            case "tel":
                return (
                    <FormPhoneInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        country_code={values['country_dial_code']}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            case "file":
                return (
                    <FormInputFile
                        key={field.name}
                        field={field}
                        handleChange={handleFileChange}
                        error={errors[field.name]}
                        imagePreview={null}
                    />
                );
            default:
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
        }
    };

    useImperativeHandle(ref, () => ({
        submitForm: () => {
            const fakeEvent = { preventDefault: () => { } };
            handleSubmit(fakeEvent, values);
        }
    }));



    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}

            <form onSubmit={(e) => handleSubmit(e, values)}>
                <div className="row g-3 overflow-x-hidden">
                    <div className="card">
                        <div className="card-header">
                            <h6 className="card-title mb-0">Guest Details</h6>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                {guest_details.map((field, idx) => (
                                    <React.Fragment key={`guest_details-${field.name}-${idx}`}>
                                        {renderField(field)}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>

    );
});